/**
 * @description 员工管理模块路由
 * @author staff-refactoring
 * @date 2026-07-21
 */

/** 员工列表 */
export const staffRouter = [
  {
    path: '/staff/list',
    name: 'staffList',
    component: () => import('views/staff/list/index.vue'),
    meta: {
      title: '员工管理'
    }
  },
  /** 员工详情 */
  {
    path: '/staff/detail',
    name: 'staffDetail',
    component: () => import('views/staff/detail/index.vue'),
    meta: {
      title: '员工详情'
    }
  },
  /** 添加员工 */
  {
    path: '/staff/add',
    name: 'staffAdd',
    component: () => import('views/staff/add/index.vue'),
    meta: {
      title: '添加员工'
    }
  },
  /** 修改员工 */
  {
    path: '/staff/edit',
    name: 'staffEdit',
    component: () => import('views/staff/edit/index.vue'),
    meta: {
      title: '修改员工信息'
    }
  },
  /** 修改员工密码 */
  {
    path: '/staff/changePassword',
    name: 'staffChangePassword',
    component: () => import('views/staff/changePassword/index.vue'),
    meta: {
      title: '修改员工密码'
    }
  },
  /** 员工收款二维码 */
  {
    path: '/staff/qrcode',
    name: 'staffQrcode',
    component: () => import('views/staff/qrcode/index.vue'),
    meta: {
      title: '员工二维码'
    }
  },
  /** 角色列表 */
  {
    path: '/staff/role/list',
    name: 'staffRoleList',
    component: () => import('views/staff/role/list/index.vue'),
    meta: {
      title: '角色管理'
    }
  },
  /** 角色详情 */
  {
    path: '/staff/role/detail',
    name: 'staffRoleDetail',
    component: () => import('views/staff/role/detail/index.vue'),
    meta: {
      title: '角色详情'
    }
  },
  /** 添加/修改角色表单 */
  {
    path: '/staff/role/form',
    name: 'staffRoleForm',
    component: () => import('views/staff/role/form/index.vue'),
    meta: {
      title: '添加角色'
    }
  }
]
